import { useEffect, useState } from 'react';
import { useRouter } from 'next/router';
import { useSession } from '@/contexts/LitSessionProvider';
import Seo from '@/components/shared/Seo';
import SettingsBackArrow from '@/components/userSettings/SettingsBackArrow';
import UserWallets from '@/components/userSettings/UserWallets';
export default function SettingsWalletPage() {
  'use no memo';

  const router = useRouter();
  const {
    PKP,
    litSession
  } = useSession();
  const [isClient, setIsClient] = useState(false);
  useEffect(() => {
    if (!litSession || !PKP) {
      router.push('/home');
    }
  }, [litSession, PKP]);
  useEffect(() => {
    setIsClient(true);
  }, []);
  if (!isClient) {
    return;
  }
  return <div className='flex flex-col lg:flex-row overflow-x-hidden overflow-y-scroll' data-sentry-component="SettingsWalletPage" data-sentry-source-file="index.tsx">
      <Seo nofollow noindex title='Wallets • Genius Terminal • Trade Crypto Like a Genius' data-sentry-element="Seo" data-sentry-source-file="index.tsx" />

      <div className='bg-genius-indigo h-screen grow'>
        <div className='w-full flex justify-between items-center mt-4 pl-4'>
          <SettingsBackArrow data-sentry-element="SettingsBackArrow" data-sentry-source-file="index.tsx" />
        </div>
        <div className='wallets-wrapper pt-5'>
          <div className='flex pl-4 items-center pb-4'>
            <div className='flex flex-col w-2/3 title text-genius-cream text-[20px] font-light'>
              Genius Cloud Wallets
            </div>
          </div>
          <UserWallets data-sentry-element="UserWallets" data-sentry-source-file="index.tsx" />
        </div>
      </div>
    </div>;
}